import React, { FC, ReactNode } from 'react'

import Box, { BoxProps } from './Box'
import Typography from './Typography'

interface BadgeProps extends BoxProps {
  children: ReactNode
  variant?: string
}

const Badge: FC<BadgeProps> = ({ children, variant = 'dark', ...props }) => {
  return (
    <Box
      {...props}
      display="inline-flex"
      alignItems="center"
      bg={variant === 'dark' ? 'primaryBrightBlue' : 'primaryBrightBlueLightBg'}
      height={18}
      px={1}
      borderRadius={9}
    >
      <Typography variant="badge" color="primaryPaleWhite" leadingTrim>
        {children}
      </Typography>
    </Box>
  )
}

export default Badge
